<template>
  <BuilderWrapper
    title="Popup"
  >
    <LabelledInput
      label="Popup Title"
    >
      <!-- A DOM Memory leak on the option tag, not on Bootstrap-Vue, or Vue but
      with vanilla JS https://github.com/vuejs/vue/issues/9823 -->
      <b-select
        v-model="popupTitleField"
        :options="fieldOptions"
        data-cy="popup-title-input"
      />
    </LabelledInput>

    <LabelledInput
      label="Popup Sub-Title"
    >
      <b-select
        v-model="popupSubtitleField"
        :options="fieldOptions"
        data-cy="popup-subtitle-input"
      />
    </LabelledInput>

    <LabelledInput>
      <b-checkbox v-model="showPopupTotal">
        Show total
      </b-checkbox>
    </LabelledInput>

    <LabelledInput v-if="!exclude.includes('piechart')">
      <b-checkbox v-model="showPopupChart">
        Show pie chart
      </b-checkbox>
    </LabelledInput>

    <!-- Show a sample popup -->
    <PopupContent
      class="my-3"
      :show-chart="showPopupChart"
      :popup-details="popup"
      :graph-id="graphId"
    />

    <LabelledInput
      label="Additional fields"
      helpful-tip="Select which fields to display below the graph"
    >
      <DraggableFields
        left-heading="Unused Fields"
        right-heading="Popup Fields"
        :source-fields.sync="fields"
        :selected-columns.sync="popupItemFields"
      />
    </LabelledInput>
  </BuilderWrapper>
</template>

<script lang="ts">

import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'

// @ts-ignore uuid not having types
import { v4 as uuidv4 } from 'uuid'
import BuilderWrapper from '@/components/builder/UI/BuilderWrapper.vue'
import LabelledInput from '@/components/builder/UI/LabelledInput.vue'
import DraggableFields from '@/components/common/DraggableFields/DraggableFields.vue'
import PopupContent from '@/components/public/Popup/PopupContent.vue'
import { APP_CONFIG_KEY } from '@/constants'
import { PopupDetails } from '@/types'

const components = {
  BuilderWrapper,
  LabelledInput,
  PopupContent,
  DraggableFields,
}

const props = {
  exclude: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
}

@Component({ components })
export default class PopupSettings extends Vue.extend({ props }) {
  graphId = 'popup-settings-' + uuidv4()

  get showPopupChart () {
    return this.$typedStore.primary.app.config.appConfig.showPopupChart
  }

  set showPopupChart (newValue) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [APP_CONFIG_KEY, 'showPopupChart'],
      value: newValue,
    })
  }

  get showPopupTotal () {
    return this.$typedStore.primary.app.config.appConfig.showPopupTotal ?? true
  }

  set showPopupTotal (newValue) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [APP_CONFIG_KEY, 'showPopupTotal'],
      value: newValue,
    })
  }

  get fields () {
    return this.$typedStore.visualisationApp.fieldMap
  }

  get popupItemFields () {
    return this.$typedStore.primary.app.config.popupItems
  }

  set popupItemFields (newArray) {
    this.$typedStore.primary.app.updateConfig({
      configPath: ['popupItems'],
      value: newArray,
    })
  }

  get popup (): PopupDetails {
    return {
      node: this.$typedStore.visualisationData.firstLeafVisNode,
    }
  }

  get fieldOptions () {
    const fields = this.fields.map((field) => {
      return { text: field.name, value: field.column }
    })
    return [{ text: 'None', value: null }, ...fields]
  }

  get popupTitleField () {
    return this.$typedStore.primary.app.config.appConfig.popupTitleField
  }

  set popupTitleField (newValue) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [APP_CONFIG_KEY, 'popupTitleField'],
      value: newValue,
    })
  }

  get popupSubtitleField () {
    return this.$typedStore.primary.app.config.appConfig.popupSubtitleField
  }

  set popupSubtitleField (newValue) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [APP_CONFIG_KEY, 'popupSubtitleField'],
      value: newValue,
    })
  }
}

</script>
